import { Text } from 'pixi.js';

// Pause/gameover/victory hero overlay text helpers — caller owns the Text instances.
// Apply consistent 88pt hero + 16pt subtitle styling with state-color glow.

export function setHeroTitle(text: Text, value: string, W: number, color: number, glowColor: number): void {
  text.text = value;
  text.anchor.set(0.5, 0.5);
  text.x = W / 2;
  text.style.fontSize = 88;
  text.style.fill = color;
  text.style.fontWeight = 'bold';
  text.style.letterSpacing = 8;
  text.style.lineHeight = 88;
  text.style.dropShadow = {
    color: glowColor, alpha: 0.95, distance: 0, angle: 0, blur: 22,
  } as any;
}

export function setHeroSub(text: Text, value: string, W: number, color: number): void {
  text.text = value;
  text.anchor.set(0.5, 0.5);
  text.x = W / 2;
  text.style.fontSize = 16;
  text.style.fill = color;
  text.style.letterSpacing = 3;
}
